import { render, staticRenderFns } from "./CustomSkeleton.vue?vue&type=template&id=28c6aa97&"
import script from "./CustomSkeleton.vue?vue&type=script&lang=js&"
export * from "./CustomSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports